import { render, staticRenderFns } from "./ManageBureaus.vue?vue&type=template&id=1ef9a7e5"
import script from "./ManageBureaus.vue?vue&type=script&lang=js"
export * from "./ManageBureaus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports